<template lang="html">
  <div class="loader">

      <p>{{progress}}</p>
      <svg id="loadersvg" width="62" height="62" xmlns="http://www.w3.org/2000/svg">
        <g >
          <circle cx="31" cy="31" r="30" fill="none" stroke-width="2" stroke-linecap="square" stroke="#333"/>
        </g>
      </svg>

  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { masterBus } from '@/main.js';
import scenarios from '../assets/furnituresScenarios.json';

export default {
  name: 'Loader',
  data(){
    return {
      progress:0
    }
  },
  computed: {
    ...mapGetters(['loader'])
  },
  mounted(){
    masterBus.$on('startLoader', this.loadImages);
  },
  methods:{
    loadImages(){
      this.$store.dispatch('setLoader',PIXI.loader);
      if(this.$route.path.indexOf('configurator')){
        let id = this.$route.params.id;
        let currentScenario = scenarios.find((o => o.url == id));
        if(currentScenario){
          if(currentScenario.useCase == 'shared experiences'){
            if(currentScenario.useCase == 'shared experiences'){
              this.loader.reset();
              this.loader.add("/assets/base/baseSprite-0.json")
              .add("/assets/scene01/scene01-0.json")
              .add("/assets/spritesheets/sharedExperiences/shared-experience-0.json")
              .add("/assets/spritesheets/sharedExperiences/shared-experience-1.json")
              .add("/assets/spritesheets/sharedExperiences/shared-experience-2.json")
              .add("/assets/spritesheets/sharedExperiences/shared-experience-3.json")
              .on('progress', (loader,res) =>{
                this.progress = loader.progress.toFixed(0);
              }).load(this.configuratorReady);
            }
          }
          else if(currentScenario.useCase == 'future of work'){
            this.loader.reset();
            this.loader.add("/assets/base/baseSprite-0.json")
            .add("/assets/spritesheets/futureOfWork/future-of-work-0.json")
            .add("/assets/spritesheets/futureOfWork/future-of-work-1.json")
            .on('progress', (loader,res) =>{
              this.progress = loader.progress.toFixed(0);;
            }).load(this.configuratorReady);
          }
          else if(currentScenario.useCase == 'utility services'){
            this.loader.reset();
            this.loader.add("/assets/base/baseSprite-0.json")
            .add("/assets/spritesheets/utilityServices/utility-services-0.json")
            .add("/assets/spritesheets/utilityServices/utility-services-1.json")
            .add("/assets/spritesheets/utilityServices/utility-services-2.json")
            .on('progress', (loader,res) =>{
              this.progress = loader.progress.toFixed(0);
            }).load(this.configuratorReady);
          }
        }
      }
    },
    configuratorReady(){
      this.configuratorIsOn = true;
      this.$store.dispatch('setAppReady',true);
      $('.loader').fadeOut(400);
      masterBus.$emit('initConfigurator');
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes ROTOR{0%,50%{transform:rotate(0deg)}to{transform:rotate(360deg)}}
@keyframes DASHLOADER{0%,to{stroke-dasharray:1px,45px;stroke-dashoffset:0}50%{stroke-dasharray:35px,45px;stroke-dashoffset:0}}
@keyframes LOADERROTORFULL{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}

#loadersvg{
  animation:ROTOR 2s ease infinite;
  -webkit-animation:ROTOR 2s ease infinite;
  transform-origin: center;
  transform: scale(3);
  position: absolute;
  bottom: calc(5% + 110px);
  right:290px;
  background: white;
  border-radius: 100px;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
  // box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
  // -webkit-box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
  // -moz-box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.16);
  g{
    width:50px;height:50px;
    transform-origin:center center;
    -webkit-animation:LOADERROTORFULL 1.6s linear infinite;
    animation:LOADERROTORFULL 1.6s linear infinite;
    circle{
      -webkit-animation:DASHLOADER 2s ease infinite;
      animation:DASHLOADER 2s ease infinite;
    }
  }

}
.loader{
  width: 100%;
  height: 100vh;
  background: #f4f4f4;
  position: fixed;
  top:0;
  left:0;
  z-index: 90000;
  p{
    z-index: 2;
    width: 58px;
    position: absolute;
    text-align: center;
    bottom: calc(5% + 128px);
    right:291px;
    font-size: 1.3rem;
  }
}
</style>
